import { Routes } from '@angular/router';
import { ContentPageComponent } from './pages';

export const routes: Routes = [
  { path: 'page', component: ContentPageComponent },
  { path: '', redirectTo: 'page', pathMatch: 'full' }
];
